import Axios, { AxiosError } from "axios";

// process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
if (process.env.NODE_ENV === "development") {
  // Axios.defaults.baseURL = process.env.VUE_APP_DOMAIN;
  // eslint-disable-next-line no-console
  console.warn(process.env.VUE_APP_DOMAIN);
}

// Axios.defaults.headers.common.Authorization = "AUTH_TOKEN";
Axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
Axios.defaults.headers.post["X-Requested-With"] = "XMLHttpRequest";
Axios.defaults.withCredentials = true;

export default Axios;
